import VerticalExpandButtonContainer from './VerticalExpandButtonContainer';

export default VerticalExpandButtonContainer;
